export const STOREFRONT_AUTH_KEY = 'zt.store.auth.user';
export const STOREFRONT_GUEST_SESSION_KEY = 'zt.store.guest_session_id';
export const STOREFRONT_CLIENT_APP = 'storefront';

const LEGACY_AUTH_KEY = 'zt.auth.user';
const LEGACY_GUEST_SESSION_KEY = 'zt_guest_session_id';

/** Node 25 + iisnode can expose a broken localStorage (getItem is not a function). */
export function canUseLocalStorage(): boolean {
  try {
    return (
      typeof localStorage !== 'undefined' &&
      typeof localStorage.getItem === 'function' &&
      typeof localStorage.setItem === 'function' &&
      typeof localStorage.removeItem === 'function'
    );
  } catch {
    return false;
  }
}

export function migrateStorefrontStorageKeys(): void {
  if (!canUseLocalStorage()) {
    return;
  }

  migrateKey(LEGACY_AUTH_KEY, STOREFRONT_AUTH_KEY);
  migrateKey(LEGACY_GUEST_SESSION_KEY, STOREFRONT_GUEST_SESSION_KEY);
}

function migrateKey(legacyKey: string, newKey: string): void {
  const legacy = localStorage.getItem(legacyKey);
  if (legacy == null) {
    return;
  }
  if (!localStorage.getItem(newKey)) {
    localStorage.setItem(newKey, legacy);
  }
  localStorage.removeItem(legacyKey);
}
